{
  "version": 1,
  "asset_id": "04a89dd5-1ffb-4079-8985-07483db3a144",
  "project_id": "1820e758-46fa-46b0-bd5a-016534d0d263",
  "url": "/__l5e/assets-v1/04a89dd5-1ffb-4079-8985-07483db3a144/ind-automotive-1200.webp",
  "r2_key": "a/v1/1820e758-46fa-46b0-bd5a-016534d0d263/04a89dd5-1ffb-4079-8985-07483db3a144/ind-automotive-1200.webp",
  "original_filename": "ind-automotive-1200.webp",
  "size": 31478,
  "content_type": "image/webp",
  "created_at": "2026-07-25T02:25:55Z"
}
